import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { Arrow } from '../components/Icons';
import ServiceCards from '../components/ServiceCards';
import ContactBanner from '../components/ContactBanner';
import services from '../data/services';
import originalCopy from '../data/originalCopy';

function Home() {
  const [playing, setPlaying] = useState(true);
  const video = useRef();
  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) setPlaying(false);
  }, []);
  useEffect(() => {
    if (!video.current) return;
    if (playing) video.current.play().catch(() => {});else video.current.pause();
  }, [playing]);
  return <>
    <section className="hero">
      <video ref={video} src="/videos/truck.mp4" poster="/mine-hero.jpg" autoPlay loop muted playsInline preload="metadata" />
      <div className="hero-shade" />
      <div className="hero-content">
        <div className="hero-eyebrow"><span className="status-dot" /> MINING & INFRASTRUCTURE</div>
        <h1>Case<span>Mining</span></h1>
        <p>We provide Project Management,<br />Planning and Scheduling,<br />Capex and Opex Estimating services.</p>
        <div className="hero-actions"><Link className="button accent-button" to="/contact">Contact us <Arrow /></Link></div>
      </div>
      <div className="hero-bottom"><span><span className="crosshair">✳</span> EDMONTON, ALBERTA</span><a href="#expertise">OUR SERVICES <span>↓</span></a><button onClick={() => setPlaying(!playing)} aria-label={playing ? 'Pause background video' : 'Play background video'}>{playing ? 'Ⅱ' : '▷'}</button></div>
    </section>
    <div className="principles-strip">{services.map(service => <span key={service.title}>{service.title}</span>)}</div>
    <section className="section expertise-section" id="expertise">
      <div className="section-heading"><div><span className="eyebrow"><i /> 01 — OUR SERVICES</span><h2>Our Services</h2></div><div className="heading-aside"><p>We provide a variety of quality services such as:</p><Link className="underlined-link" to="/services">Our Services <Arrow diagonal /></Link></div></div>
      <ServiceCards />
    </section>
    <section className="about-section" id="about">
      <div className="about-visual"><img src="/background-2.jpg" alt="Haul trucks on the terraced benches of an open-pit mine" loading="lazy" /><div className="image-note"><span>CASE MINING CONSULTANTS</span><span>2007 ↗</span></div><div className="photo-corner" /></div>
      <div className="about-copy"><span className="eyebrow"><i /> 02 — ABOUT US</span><h2>Who We Are</h2><p>{originalCopy.history}</p><div className="about-values"><h3>Our Values</h3><p>{originalCopy.values}</p></div></div>
    </section>
    <section className="section approach-section"><span className="eyebrow"><i /> 03 — WHAT WE DO</span><div className="approach-layout"><h2>What We Do</h2><div className="original-about-text"><p>{originalCopy.whatWeDo}</p><p>{originalCopy.collaboration}</p></div></div></section>
    <ContactBanner />
  </>;
}

export default Home;
